import ContentArea from './ContentArea';

export default ContentArea;
